// TODO: maybe not the best idea to do this here but we need access to it from other places in the client code so for now it's what we have :|
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IWorklinkScenarioListSettings, IWorklinkSettings, ScenarioSortAttributes } from "../../interfaces/Worklink";
import { SortDirections } from "../../interfaces/Misc";

export interface IWorklinkState
{
	settings: IWorklinkSettings;
	dashboardRevisionGroup: {
		name: string;
		id: string;
	};
}

const initialState = {
	settings: {
		scenarioList: {
			pageSize: 25,
			sortingMethod: SortDirections.Ascending,
			sortingAttribute: ScenarioSortAttributes.Name,
		}
	},
	dashboardRevisionGroup: {
		name: "",
		id: "",
	},
};

const worklinkSlice = createSlice({
	name: "worklink",
	initialState,
	reducers: {
		setSettings(state, action: PayloadAction<IWorklinkSettings>) 
		{
			state.settings = { ...action.payload };
		},
		setScenarioListSettings(state, action: PayloadAction<Partial<IWorklinkScenarioListSettings>>)
		{
			state.settings.scenarioList = { ...state.settings.scenarioList, ...action.payload };
		},
		setDashboardRevisionGroup(state, action: PayloadAction<{ name: string; id: string }>)
		{
			state.dashboardRevisionGroup = action.payload;
		},
	}
});

export default worklinkSlice;